<template>
  <div class="flex flex-col items-stretch p-1 bg-gray-200">
    <div class="flex my-1">
      <select required class="inp my-1 p-1 w-1/2" v-model="country">
        <option disabled selected value="">{{$t('form.country.placeholder')}}</option>
        <option v-for="code in countryCodes" :key="code" :value="code">{{$t('countries.' + code)}}</option>
      </select>
      <select required class="inp my-1 p-1 w-1/2" v-if="country == 'CH' || country == 'IT'" v-model="region">
        <template v-if="country == 'CH'">
          <option disabled selected value="">{{$t('form.canton.placeholder')}}</option>
          <option v-for="canton in cantons" :key="canton" :value="canton">{{ canton }}</option>
        </template>
        <template v-else>
          <option disabled selected value="">{{$t('form.region.placeholder')}}</option>
          <option v-for="region in regions" :key="region" :value="region">{{ region }}</option>
        </template>
      </select>
    </div>
    <button class="btn btn-1 my-1" @click="send()">Ok</button>
  </div>
</template>

<script>

import countryCodes from '@/lib/countryCodes.json'
import regionCodes from '@/lib/regionCodes.json'

export default {
  data() {
    return {
      countryCodes,
      regions: Object.values(regionCodes['IT']).filter((v, i, s) => s.indexOf(v) == i), //filter unique
      cantons: Object.values(regionCodes['CH']),
      country: '',
      region: '',
    }
  },
  methods: {
    send() {
      this.$emit('input', {country: this.country, region: this.region})
    }
  }
}
</script>

<style>

</style>